<template>
  <page-container>
    <div class="landing-page">
      <transition name="modal">
        <offer-modal
          v-show="showModal"
          @close-modal="toggleModal"
        ></offer-modal>
      </transition>
      <section class="onboard">
        <h1>Functional design</h1>
        <h2>with a twist of</h2>
        <div class="highlight">
          <h2>elegance</h2>
          <div class="line"></div>
        </div>
        <!-- <h1>
          <span>Functional design</span><span>with a twist of</span
          ><span
            ><div class="highlight">
              elegance
              <div class="line"></div></div
          ></span>
        </h1> -->
        <img src="@/assets/svg/chevron.svg" alt="chevron" class="chevron" />
      </section>

      <section class="showcase">
        <div class="projects" ref="projectsSlider">
          <project-card
            v-for="(project, index) in projects.slice(0, 4)"
            :key="index"
            :project="project"
          ></project-card>
          <div class="project" v-show="loaded">
            <div class="project-title-container">
              <h3 class="project-title">Projects</h3>
            </div>
            <div class="project-content">
              <div class="content-cover">
                <img
                  v-for="(project, index) in moreProjects"
                  :key="index"
                  :src="project.cover.desktop"
                  alt="project"
                  class="content-cover-img"
                  loading="lazy"
                />
              </div>
              <div class="description">
                <p class="description-text">
                  There's plenty more goodness to see
                </p>
                <div class="description-link">
                  <router-link
                    :to="{ name: 'Projects' }"
                    class="description-link-btn"
                    >See more</router-link
                  >
                  <div
                    class="description-link-background"
                    @click="routeToProjects"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="selector" ref="selector">
          <div
            class="selector-btn active"
            @click="scroll(0)"
            data-btn="btn-1"
          ></div>
          <div class="selector-btn" @click="scroll(1)"></div>
          <div class="selector-btn" @click="scroll(2)"></div>
          <div class="selector-btn" @click="scroll(3)"></div>
          <div class="selector-btn" @click="scroll(4)"></div>
        </div>
      </section>

      <section class="testimonials">
        <img
          src="@/assets/svg/chevron.svg"
          alt="arrow"
          id="right-arrow"
          @click="slideRight()"
          v-show="showRightArr"
        />
        <img
          src="@/assets/svg/chevron.svg"
          alt="arrow"
          id="left-arrow"
          @click="slideLeft()"
          v-show="showLeftArr"
        />
        <div
          class="testimonials-slider"
          :style="{
            width: `${testimonials.length * 100}vw`,
          }"
          ref="testimonialSlider"
        >
          <div
            class="testimonial"
            v-for="(testimonial, idx) in testimonials"
            :key="idx"
          >
            <div class="testimony">
              <img
                src="@/assets/svg/quote-left.svg"
                alt="quote"
                id="quote-left"
              />
              <p class="testimony-comment">
                {{ testimonial.comment }}
              </p>
              <img
                src="@/assets/svg/quote-right.svg"
                alt="quote"
                id="quote-right"
              />
            </div>
            <div class="divider"></div>
            <div class="profile">
              <div
                class="profile-img-container"
                :style="{
                  backgroundImage: `url(${testimonial.img})`,
                }"
              ></div>
              <div class="profile-details">
                <h3 class="name">{{ testimonial.name }}</h3>
                <p class="title">{{ testimonial.title }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="contact" id="contact">
        <h3 class="contact-title">Let's do bizness</h3>
        <form @submit.prevent="submitForm" class="contact-form" ref="form">
          <div class="form-control">
            <label for="email" class="form-control-label">Email</label>
            <input
              type="email"
              class="email-input form-control-input"
              name="email"
              v-model="email"
              ref="email"
              required
            />
          </div>
          <div class="form-control">
            <label for="message" class="form-control-label"
              >How can I help ?</label
            >
            <textarea
              name="message"
              class="message-input form-control-input"
              v-model="message"
              ref="contactMsg"
              required
            ></textarea>
          </div>
          <p v-show="error" class="error">{{ errorMsg }}</p>
          <button
            class="contact-btn"
            :class="{ 'btn-success': success }"
            ref="contactBtn"
          >
            <img
              src="@/assets/svg/check.svg"
              alt="check-svg"
              class="contact-btn-icon"
              v-show="success"
            />
            <span v-show="!isLoading & !success">Send</span>

            <loading-spinner v-show="isLoading & !success"></loading-spinner>
          </button>
        </form>
      </section>

      <section class="offer">
        <div class="title-container">
          <p class="offer-title"><span>Free</span> Website</p>
          <p class="offer-title">Analysis Report</p>
        </div>
        <button class="offer-btn" @click="toggleModal">Sign Up</button>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1354.687"
          height="229.021"
          viewBox="0 0 1354.687 229.021"
          id="svg"
        >
          <g transform="matrix(1, 0, 0, -1, -16.539, 465.521)">
            <path
              d="M20,378.723l.887,1.354.887,1.35.887,1.346.887,1.34.887,1.335.887,1.33.887,1.324.887,1.318.887,1.313.887,1.306.887,1.3.887,1.293.887,1.286.887,1.279.887,1.272.887,1.264.887,1.257.887,1.249.887,1.241.887,1.233.887,1.225.887,1.216.887,1.207.887,1.2.887,1.189.887,1.18.887,1.17.887,1.161.887,1.15.887,1.141.887,1.13.887,1.119.887,1.11.887,1.1.887,1.088.887,1.076.887,1.066.887,1.053.887,1.042.887,1.03.887,1.018.887,1.007.887.994.887.982.887.969.887.957.887.943.887.931.887.917.887.9.887.891.887.877.887.864.887.849.887.836.887.822.887.807.887.792.887.779.887.764.887.749.887.734.887.719.887.7.887.689.887.673.887.658.887.643.887.627.887.612.887.6.887.58.887.564.887.548.887.532.887.515.887.5.887.482.887.467.887.45.887.433.887.416.887.4.887.383.887.366.887.349.887.332.887.315.887.3.887.281.887.263.887.247.887.229.887.212.887.194.887.177.887.16.887.143.887.125.887.108.887.09.887.073.887.056.887.038.887.02.887,0,.887-.015.887-.032.887-.049.887-.067.887-.085.887-.1.887-.12.887-.137.887-.155.887-.172.887-.189.887-.206.887-.224.887-.241.887-.258.887-.276.887-.292.887-.31.887-.326.887-.344.887-.361.887-.377.887-.394.887-.411.887-.427.887-.445.887-.461.887-.478.887-.493.887-.511.887-.526.887-.542.887-.559.887-.575.887-.59.887-.606.887-.623.887-.638.887-.654.887-.669.887-.684.887-.7.887-.714.887-.73.887-.744.887-.759.887-.773.887-.788.887-.8.887-.817.887-.831.887-.845.887-.859.887-.873.887-.886.887-.9.887-.913.887-.926.887-.939.887-.952.887-.965.887-.978.887-.99.887-1,.887-1.015.887-1.026.887-1.038.887-1.05.887-1.062.887-1.073.887-1.084.887-1.095.887-1.106.887-1.117.887-1.127.887-1.137.887-1.147.887-1.158.887-1.167.887-1.176.887-1.186.887-1.195.887-1.2.887-1.213.887-1.222.887-1.23.887-1.238.887-1.247.887-1.255.887-1.262.887-1.27.887-1.277.887-1.284.887-1.29.887-1.3.887-1.3.887-1.31.887-1.317.887-1.322.887-1.328.887-1.333.887-1.339.887-1.343.887-1.348.887-1.353.887-1.357.887-1.362.887-1.365.887-1.369.887-1.373.887-1.376.887-1.379.887-1.382.887-1.385.887-1.387.887-1.389.887-1.392.887-1.393.887-1.395.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.394.887-1.393.887-1.391.887-1.389.887-1.387.887-1.384.887-1.381.887-1.379.887-1.375.887-1.372.887-1.368.887-1.364.887-1.36.887-1.356.887-1.352.887-1.346.887-1.342.887-1.337.887-1.332.887-1.326.887-1.32.887-1.315.887-1.308.887-1.3.887-1.3.887-1.288.887-1.282.887-1.274.887-1.267.887-1.26.887-1.251.887-1.244.887-1.236.887-1.227.887-1.219.887-1.21.887-1.2.887-1.192.887-1.183.887-1.173.887-1.163.887-1.154.887-1.144.887-1.134.887-1.123.887-1.113.887-1.1.887-1.091.887-1.08.887-1.069.887-1.058.887-1.046.887-1.034.887-1.023.887-1.01.887-1,.887-.985.887-.974.887-.961.887-.948.887-.935.887-.922.887-.908.887-.9.887-.882.887-.868.887-.854.887-.84.887-.827.887-.812.887-.8.887-.783.887-.768.887-.754.887-.739.887-.724.887-.709.887-.694.887-.679.887-.663.887-.648.887-.632.887-.617.887-.6.887-.585.887-.569.887-.553.887-.537.887-.521.887-.505.887-.488.887-.471.887-.456.887-.438.887-.422.887-.405.887-.388.887-.372.887-.355.887-.338.887-.32.887-.3.887-.287.887-.27.887-.252.887-.235.887-.217.887-.2.887-.183.887-.166.887-.148.887-.131.887-.113.887-.1.887-.078.887-.061.887-.044.887-.025.887-.009.887.009.887.026.887.044.887.062.887.078.887.1.887.113.887.131.887.148.887.166.887.183.887.2.887.218.887.236.887.252.887.27.887.287.887.3.887.321.887.338.887.355.887.372.887.388.887.406.887.422.887.439.887.456.887.471.887.489.887.505.887.521.887.537.887.553.887.57.887.585.887.6.887.617.887.633.887.648.887.664.887.679.887.694.887.71.887.724.887.739.887.754.887.769.887.783.887.8.887.812.887.826.887.84.887.855.887.868.887.882.887.9.887.909.887.922.887.935.887.948.887.961.887.974.887.986.887,1,.887,1.01.887,1.023.887,1.034.887,1.046.887,1.058.887,1.069.887,1.081.887,1.091.887,1.1.887,1.113.887,1.124.887,1.134.887,1.144.887,1.154.887,1.163.887,1.174.887,1.183.887,1.192.887,1.2.887,1.21.887,1.218.887,1.228.887,1.236.887,1.244.887,1.252.887,1.26.887,1.266.887,1.275.887,1.282.887,1.288.887,1.3.887,1.3.887,1.308.887,1.315.887,1.32.887,1.326.887,1.331.887,1.337.887,1.341.887,1.347.887,1.352.887,1.356.887,1.36.887,1.365.887,1.367.887,1.372.887,1.376.887,1.378.887,1.381.887,1.384.887,1.387.887,1.389.887,1.391.887,1.393.887,1.394.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.395.887,1.393.887,1.392.887,1.389.887,1.387.887,1.385.887,1.382.887,1.379.887,1.376.887,1.373.887,1.37.887,1.365.887,1.361.887,1.357.887,1.353.887,1.348.887,1.343.887,1.338.887,1.333.887,1.328.887,1.322.887,1.316.887,1.31.887,1.3.887,1.3.887,1.291.887,1.284.887,1.276.887,1.27.887,1.262.887,1.254.887,1.247.887,1.238.887,1.23.887,1.221.887,1.214.887,1.2.887,1.2.887,1.185.887,1.176.887,1.167.887,1.157.887,1.148.887,1.137.887,1.127.887,1.116.887,1.106.887,1.095.887,1.084.887,1.072.887,1.062.887,1.049.887,1.038.887,1.027.887,1.014.887,1,.887.99.887.977.887.965.887.952.887.939.887.926.887.913.887.9.887.886.887.872.887.859.887.845.887.831.887.817.887.8.887.788.887.773.887.759.887.743.887.729.887.714.887.7.887.684.887.668.887.654.887.637.887.622.887.607.887.59.887.574.887.559.887.542.887.526.887.51.887.493.887.477.887.461.887.444.887.427.887.411.887.394.887.377.887.36.887.344.887.326.887.309.887.293.887.275.887.258.887.24.887.223.887.206.887.189.887.171.887.155.887.136.887.12.887.1.887.085.887.067.887.049.887.032.887.014.887,0,.887-.021.887-.038L563,462.9l.887-.073.887-.091.887-.108.887-.126.887-.143.887-.16.887-.178.887-.2.887-.212.887-.229.887-.247.887-.264.887-.282.887-.3.887-.315.887-.333.887-.35.887-.366.887-.383.887-.4.887-.416.887-.434.887-.45.887-.467.887-.483.887-.5.887-.515.887-.533.887-.548.887-.564.887-.581.887-.6.887-.612.887-.628.887-.643.887-.658.887-.674.887-.689.887-.7.887-.719.887-.735.887-.75.887-.764.887-.779.887-.793.887-.807.887-.822.887-.836.887-.849.887-.864.887-.878.887-.891.887-.9.887-.917.887-.931.887-.944.887-.957.887-.97.887-.982.887-.994.887-1.007.887-1.018.887-1.031.887-1.042.887-1.054.887-1.065.887-1.077.887-1.088.887-1.1.887-1.109.887-1.12.887-1.131.887-1.141.887-1.15.887-1.161.887-1.17.887-1.18.887-1.19.887-1.2.887-1.207.887-1.216.887-1.225.887-1.233.887-1.241.887-1.249.887-1.257.887-1.265.887-1.272.887-1.279.887-1.286.887-1.293.887-1.3.887-1.306.887-1.313.887-1.318.887-1.324.887-1.33.887-1.335.887-1.34.887-1.346.887-1.35.887-1.354.887-1.359.887-1.363.887-1.367.887-1.37.887-1.374.887-1.377.887-1.381.887-1.383.887-1.386.887-1.388.887-1.39.887-1.392.887-1.394.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.395.887-1.394.887-1.392.887-1.39.887-1.388.887-1.385.887-1.383.887-1.38.887-1.377.887-1.374.887-1.37.887-1.367.887-1.363.887-1.359.887-1.354.887-1.35.887-1.345.887-1.34.887-1.335.887-1.33.887-1.324.887-1.318.887-1.312.887-1.306.887-1.3.887-1.293.887-1.286.887-1.279.887-1.272.887-1.264.887-1.257.887-1.249.887-1.241.887-1.233.887-1.225.887-1.216.887-1.207.887-1.2.887-1.189.887-1.179.887-1.17.887-1.161.887-1.15.887-1.14.887-1.13.887-1.119.887-1.109.887-1.1.887-1.087.887-1.076.887-1.065.887-1.053.887-1.042.887-1.031.887-1.018.887-1.007.887-.994.887-.981.887-.969.887-.957.887-.944.887-.93.887-.917.887-.9.887-.891.887-.877.887-.863.887-.849.887-.836.887-.821.887-.807.887-.793.887-.778.887-.763.887-.749.887-.734.887-.719.887-.7.887-.689.887-.673.887-.658.887-.642.887-.627.887-.611.887-.6.887-.579.887-.564.887-.547.887-.532.887-.515.887-.5.887-.483.887-.466.887-.449.887-.433.887-.416.887-.4.887-.383.887-.366.887-.349.887-.332.887-.315.887-.3.887-.281.887-.263.887-.246.887-.23.887-.212.887-.194.887-.177.887-.159.887-.142.887-.125.887-.107.887-.09.887-.073.887-.055.887-.037.887-.021.887,0,.887.014.887.033.887.049.887.067.887.085.887.1.887.12.887.137.887.155.887.172.887.19.887.207.887.224.887.241.887.258.887.276.887.293.887.31.887.327.887.344.887.361.887.378.887.394.887.412.887.428.887.445.887.461.887.478.887.494.887.511.887.526.887.543.887.559.887.575.887.59.887.607.887.623.887.638.887.654.887.669.887.684.887.7.887.715.887.73.887.744.887.759.887.774.887.788.887.8.887.817.887.831.887.845.887.859.887.873.887.886.887.9.887.913.887.926.887.939.887.953.887.965.887.978.887.99.887,1,.887,1.015.887,1.027.887,1.039.887,1.05.887,1.062.887,1.073.887,1.084.887,1.1.887,1.106L848.7,284l.887,1.127.887,1.137.887,1.148.887,1.158.887,1.167.887,1.177.887,1.186.887,1.2.887,1.2.887,1.213.887,1.223.887,1.23.887,1.238.887,1.247.887,1.255.887,1.262.887,1.269.887,1.277.887,1.284.887,1.291.887,1.3.887,1.3.887,1.31.887,1.317.887,1.322.887,1.328.887,1.333.887,1.339.887,1.343.887,1.348.887,1.353.887,1.358.887,1.361.887,1.365.887,1.37.887,1.373.887,1.376.887,1.38.887,1.382.887,1.385.887,1.387.887,1.389.887,1.392.887,1.393.887,1.395.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.394.887,1.393.887,1.391.887,1.389.887,1.386.887,1.384.887,1.381.887,1.378.887,1.375.887,1.371.887,1.368.887,1.364.887,1.36.887,1.356.887,1.352.887,1.346.887,1.342.887,1.337.887,1.331.887,1.326.887,1.32.887,1.315.887,1.308.887,1.3.887,1.3.887,1.288.887,1.282.887,1.274.887,1.267.887,1.259.887,1.252.887,1.243.887,1.236.887,1.227.887,1.218.887,1.21.887,1.2.887,1.192.887,1.183.887,1.173.887,1.163.887,1.154.887,1.143.887,1.134.887,1.123.887,1.113.887,1.1.887,1.091.887,1.08.887,1.069.887,1.058.887,1.046.887,1.034.887,1.022.887,1.01.887,1,.887.986.887.973.887.96.887.948.887.935.887.922.887.908.887.9.887.881.887.868.887.853.887.84.887.826.887.812.887.8.887.783.887.768.887.754.887.739.887.724.887.709.887.694.887.678.887.663.887.648.887.632.887.617.887.6.887.585.887.569.887.552.887.537.887.521.887.5.887.488.887.471.887.455.887.438.887.422.887.4.887.388.887.371.887.355.887.337.887.321.887.3.887.287.887.269.887.252.887.234.887.218.887.2.887.183.887.166.887.148.887.131.887.113.887.1.887.078.887.06.887.043.887.026.887.008.887-.009.887-.027.887-.045.887-.061.887-.08.887-.1.887-.114.887-.132.887-.148.887-.167.887-.184.887-.2.887-.219.887-.236.887-.253.887-.27.887-.287.887-.3.887-.321.887-.339.887-.355.887-.372.887-.39.887-.405.887-.423.887-.439.887-.456.887-.472.887-.489.887-.505.887-.522.887-.537.887-.554.887-.57.887-.585.887-.6.887-.617.887-.633.887-.649.887-.664.887-.68.887-.694.887-.71.887-.725.887-.739.887-.755.887-.769.887-.784.887-.8.887-.813L1051,441l.887-.84.887-.855.887-.869.887-.882.887-.9.887-.909.887-.922.887-.935.887-.948.887-.961.887-.974.887-.987.887-1,.887-1.011.887-1.023.887-1.035.887-1.047.887-1.058.887-1.069.887-1.081.887-1.091.887-1.1.887-1.113.887-1.124.887-1.134.887-1.144.887-1.154.887-1.163.887-1.174.887-1.183.887-1.192.887-1.2.887-1.21.887-1.219.887-1.227.887-1.236.887-1.244.887-1.252.887-1.26.887-1.267.887-1.275.887-1.282.887-1.289.887-1.3.887-1.3.887-1.308.887-1.315.887-1.32.887-1.326.887-1.332.887-1.337.887-1.342.887-1.347.887-1.352.887-1.356.887-1.361.887-1.364.887-1.368.887-1.372.887-1.375.887-1.378.887-1.381.887-1.384.887-1.387.887-1.389.887-1.391.887-1.393.887-1.394.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.395.887-1.393.887-1.392.887-1.389.887-1.387.887-1.385.887-1.383.887-1.379.887-1.376.887-1.373.887-1.369.887-1.365.887-1.361.887-1.357.887-1.353.887-1.348.887-1.343.887-1.339.887-1.333.887-1.328.887-1.321.887-1.316.887-1.31.887-1.3.887-1.3.887-1.291.887-1.284.887-1.276.887-1.269.887-1.262.887-1.253.887-1.247.887-1.238.887-1.23.887-1.221.887-1.213.887-1.2.887-1.2.887-1.185.887-1.176.887-1.167.887-1.157.887-1.147.887-1.137.887-1.126.887-1.116.887-1.106.887-1.095.887-1.083.887-1.073.887-1.061.887-1.049.887-1.038.887-1.026.887-1.014.887-1,.887-.99.887-.977.887-.965.887-.952.887-.939.887-.926.887-.913.887-.9.887-.886.887-.873.887-.858.887-.845.887-.83.887-.817.887-.8.887-.788.887-.773.887-.759.887-.744.887-.729.887-.714.887-.7.887-.684.887-.669.887-.652.887-.638.887-.621.887-.606.887-.59.887-.574.887-.558.887-.542.887-.526.887-.51.887-.493.887-.476.887-.46.887-.444.887-.427.887-.41.887-.394.887-.377.887-.36.887-.343.887-.326.887-.309.887-.292.887-.275.887-.258.887-.24.887-.223.887-.205.887-.189.887-.171.887-.153.887-.137.887-.119.887-.1.887-.085.887-.066.887-.049.887-.031.887-.014.887,0,.887.021.887.038.887.056.887.074.887.091.887.109.887.126.887.144.887.161.887.178.887.2.887.212.887.23.887.247.887.265.887.281.887.3.887.315.887.333.887.35.887.366.887.384.887.4.887.417.887.434.887.451.887.467.887.484.887.5.887.516.887.532.887.549.887.564.887.581.887.6.887.612.887.628.887.643.887.659.887.675.887.689.887.705.887.719.887.735.887.75.887.765.887.779.887.794.887.807.887.823.887.836.887.85.887.864.887.878.887.891.887.9.887.918.887.931.887.944.887.957.887.97.887.983.887.994.887,1.007.887,1.019.887,1.031.887,1.042.887,1.054.887,1.066.887,1.077.887,1.088.887,1.1.887,1.11.887,1.12.887,1.131.887,1.141.887,1.151.887,1.161.887,1.171.887,1.18.887,1.19.887,1.2.887,1.207.887,1.216.887,1.225.887,1.233.887,1.241.887,1.249.887,1.258.887,1.264.887,1.273.887,1.279.887,1.286.887,1.293.887,1.3.887,1.306.887,1.313.887,1.318.887,1.324.887,1.33.887,1.335.887,1.341.887,1.346.887,1.35.887,1.354.887,1.359.887,1.363.887,1.367.887,1.371.887,1.374.887,1.378.887,1.38.887,1.383.887,1.386.887,1.388.887,1.39.887,1.392.887,1.394.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.395.887,1.394.887,1.392.887,1.39.887,1.388.887,1.385.887,1.383.887,1.38.887,1.377.887,1.374.887,1.37.887,1.367.887,1.363.887,1.359.887,1.354.887,1.35.887,1.345.887,1.34.887,1.335.887,1.33.887,1.324.887,1.318.887,1.313.887,1.306.887,1.3"
              fill="none"
              stroke="#02063b"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-miterlimit="10"
              stroke-width="5"
              id="path-2"
            />
          </g>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1354.687"
          height="229.021"
          viewBox="0 0 1354.687 229.021"
          id="svg"
        >
          <g transform="translate(-16.539 -236.5)">
            <path
              d="M20,378.723l.887,1.354.887,1.35.887,1.346.887,1.34.887,1.335.887,1.33.887,1.324.887,1.318.887,1.313.887,1.306.887,1.3.887,1.293.887,1.286.887,1.279.887,1.272.887,1.264.887,1.257.887,1.249.887,1.241.887,1.233.887,1.225.887,1.216.887,1.207.887,1.2.887,1.189.887,1.18.887,1.17.887,1.161.887,1.15.887,1.141.887,1.13.887,1.119.887,1.11.887,1.1.887,1.088.887,1.076.887,1.066.887,1.053.887,1.042.887,1.03.887,1.018.887,1.007.887.994.887.982.887.969.887.957.887.943.887.931.887.917.887.9.887.891.887.877.887.864.887.849.887.836.887.822.887.807.887.792.887.779.887.764.887.749.887.734.887.719.887.7.887.689.887.673.887.658.887.643.887.627.887.612.887.6.887.58.887.564.887.548.887.532.887.515.887.5.887.482.887.467.887.45.887.433.887.416.887.4.887.383.887.366.887.349.887.332.887.315.887.3.887.281.887.263.887.247.887.229.887.212.887.194.887.177.887.16.887.143.887.125.887.108.887.09.887.073.887.056.887.038.887.02.887,0,.887-.015.887-.032.887-.049.887-.067.887-.085.887-.1.887-.12.887-.137.887-.155.887-.172.887-.189.887-.206.887-.224.887-.241.887-.258.887-.276.887-.292.887-.31.887-.326.887-.344.887-.361.887-.377.887-.394.887-.411.887-.427.887-.445.887-.461.887-.478.887-.493.887-.511.887-.526.887-.542.887-.559.887-.575.887-.59.887-.606.887-.623.887-.638.887-.654.887-.669.887-.684.887-.7.887-.714.887-.73.887-.744.887-.759.887-.773.887-.788.887-.8.887-.817.887-.831.887-.845.887-.859.887-.873.887-.886.887-.9.887-.913.887-.926.887-.939.887-.952.887-.965.887-.978.887-.99.887-1,.887-1.015.887-1.026.887-1.038.887-1.05.887-1.062.887-1.073.887-1.084.887-1.095.887-1.106.887-1.117.887-1.127.887-1.137.887-1.147.887-1.158.887-1.167.887-1.176.887-1.186.887-1.195.887-1.2.887-1.213.887-1.222.887-1.23.887-1.238.887-1.247.887-1.255.887-1.262.887-1.27.887-1.277.887-1.284.887-1.29.887-1.3.887-1.3.887-1.31.887-1.317.887-1.322.887-1.328.887-1.333.887-1.339.887-1.343.887-1.348.887-1.353.887-1.357.887-1.362.887-1.365.887-1.369.887-1.373.887-1.376.887-1.379.887-1.382.887-1.385.887-1.387.887-1.389.887-1.392.887-1.393.887-1.395.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.394.887-1.393.887-1.391.887-1.389.887-1.387.887-1.384.887-1.381.887-1.379.887-1.375.887-1.372.887-1.368.887-1.364.887-1.36.887-1.356.887-1.352.887-1.346.887-1.342.887-1.337.887-1.332.887-1.326.887-1.32.887-1.315.887-1.308.887-1.3.887-1.3.887-1.288.887-1.282.887-1.274.887-1.267.887-1.26.887-1.251.887-1.244.887-1.236.887-1.227.887-1.219.887-1.21.887-1.2.887-1.192.887-1.183.887-1.173.887-1.163.887-1.154.887-1.144.887-1.134.887-1.123.887-1.113.887-1.1.887-1.091.887-1.08.887-1.069.887-1.058.887-1.046.887-1.034.887-1.023.887-1.01.887-1,.887-.985.887-.974.887-.961.887-.948.887-.935.887-.922.887-.908.887-.9.887-.882.887-.868.887-.854.887-.84.887-.827.887-.812.887-.8.887-.783.887-.768.887-.754.887-.739.887-.724.887-.709.887-.694.887-.679.887-.663.887-.648.887-.632.887-.617.887-.6.887-.585.887-.569.887-.553.887-.537.887-.521.887-.505.887-.488.887-.471.887-.456.887-.438.887-.422.887-.405.887-.388.887-.372.887-.355.887-.338.887-.32.887-.3.887-.287.887-.27.887-.252.887-.235.887-.217.887-.2.887-.183.887-.166.887-.148.887-.131.887-.113.887-.1.887-.078.887-.061.887-.044.887-.025.887-.009.887.009.887.026.887.044.887.062.887.078.887.1.887.113.887.131.887.148.887.166.887.183.887.2.887.218.887.236.887.252.887.27.887.287.887.3.887.321.887.338.887.355.887.372.887.388.887.406.887.422.887.439.887.456.887.471.887.489.887.505.887.521.887.537.887.553.887.57.887.585.887.6.887.617.887.633.887.648.887.664.887.679.887.694.887.71.887.724.887.739.887.754.887.769.887.783.887.8.887.812.887.826.887.84.887.855.887.868.887.882.887.9.887.909.887.922.887.935.887.948.887.961.887.974.887.986.887,1,.887,1.01.887,1.023.887,1.034.887,1.046.887,1.058.887,1.069.887,1.081.887,1.091.887,1.1.887,1.113.887,1.124.887,1.134.887,1.144.887,1.154.887,1.163.887,1.174.887,1.183.887,1.192.887,1.2.887,1.21.887,1.218.887,1.228.887,1.236.887,1.244.887,1.252.887,1.26.887,1.266.887,1.275.887,1.282.887,1.288.887,1.3.887,1.3.887,1.308.887,1.315.887,1.32.887,1.326.887,1.331.887,1.337.887,1.341.887,1.347.887,1.352.887,1.356.887,1.36.887,1.365.887,1.367.887,1.372.887,1.376.887,1.378.887,1.381.887,1.384.887,1.387.887,1.389.887,1.391.887,1.393.887,1.394.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.395.887,1.393.887,1.392.887,1.389.887,1.387.887,1.385.887,1.382.887,1.379.887,1.376.887,1.373.887,1.37.887,1.365.887,1.361.887,1.357.887,1.353.887,1.348.887,1.343.887,1.338.887,1.333.887,1.328.887,1.322.887,1.316.887,1.31.887,1.3.887,1.3.887,1.291.887,1.284.887,1.276.887,1.27.887,1.262.887,1.254.887,1.247.887,1.238.887,1.23.887,1.221.887,1.214.887,1.2.887,1.2.887,1.185.887,1.176.887,1.167.887,1.157.887,1.148.887,1.137.887,1.127.887,1.116.887,1.106.887,1.095.887,1.084.887,1.072.887,1.062.887,1.049.887,1.038.887,1.027.887,1.014.887,1,.887.99.887.977.887.965.887.952.887.939.887.926.887.913.887.9.887.886.887.872.887.859.887.845.887.831.887.817.887.8.887.788.887.773.887.759.887.743.887.729.887.714.887.7.887.684.887.668.887.654.887.637.887.622.887.607.887.59.887.574.887.559.887.542.887.526.887.51.887.493.887.477.887.461.887.444.887.427.887.411.887.394.887.377.887.36.887.344.887.326.887.309.887.293.887.275.887.258.887.24.887.223.887.206.887.189.887.171.887.155.887.136.887.12.887.1.887.085.887.067.887.049.887.032.887.014.887,0,.887-.021.887-.038L563,462.9l.887-.073.887-.091.887-.108.887-.126.887-.143.887-.16.887-.178.887-.2.887-.212.887-.229.887-.247.887-.264.887-.282.887-.3.887-.315.887-.333.887-.35.887-.366.887-.383.887-.4.887-.416.887-.434.887-.45.887-.467.887-.483.887-.5.887-.515.887-.533.887-.548.887-.564.887-.581.887-.6.887-.612.887-.628.887-.643.887-.658.887-.674.887-.689.887-.7.887-.719.887-.735.887-.75.887-.764.887-.779.887-.793.887-.807.887-.822.887-.836.887-.849.887-.864.887-.878.887-.891.887-.9.887-.917.887-.931.887-.944.887-.957.887-.97.887-.982.887-.994.887-1.007.887-1.018.887-1.031.887-1.042.887-1.054.887-1.065.887-1.077.887-1.088.887-1.1.887-1.109.887-1.12.887-1.131.887-1.141.887-1.15.887-1.161.887-1.17.887-1.18.887-1.19.887-1.2.887-1.207.887-1.216.887-1.225.887-1.233.887-1.241.887-1.249.887-1.257.887-1.265.887-1.272.887-1.279.887-1.286.887-1.293.887-1.3.887-1.306.887-1.313.887-1.318.887-1.324.887-1.33.887-1.335.887-1.34.887-1.346.887-1.35.887-1.354.887-1.359.887-1.363.887-1.367.887-1.37.887-1.374.887-1.377.887-1.381.887-1.383.887-1.386.887-1.388.887-1.39.887-1.392.887-1.394.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.395.887-1.394.887-1.392.887-1.39.887-1.388.887-1.385.887-1.383.887-1.38.887-1.377.887-1.374.887-1.37.887-1.367.887-1.363.887-1.359.887-1.354.887-1.35.887-1.345.887-1.34.887-1.335.887-1.33.887-1.324.887-1.318.887-1.312.887-1.306.887-1.3.887-1.293.887-1.286.887-1.279.887-1.272.887-1.264.887-1.257.887-1.249.887-1.241.887-1.233.887-1.225.887-1.216.887-1.207.887-1.2.887-1.189.887-1.179.887-1.17.887-1.161.887-1.15.887-1.14.887-1.13.887-1.119.887-1.109.887-1.1.887-1.087.887-1.076.887-1.065.887-1.053.887-1.042.887-1.031.887-1.018.887-1.007.887-.994.887-.981.887-.969.887-.957.887-.944.887-.93.887-.917.887-.9.887-.891.887-.877.887-.863.887-.849.887-.836.887-.821.887-.807.887-.793.887-.778.887-.763.887-.749.887-.734.887-.719.887-.7.887-.689.887-.673.887-.658.887-.642.887-.627.887-.611.887-.6.887-.579.887-.564.887-.547.887-.532.887-.515.887-.5.887-.483.887-.466.887-.449.887-.433.887-.416.887-.4.887-.383.887-.366.887-.349.887-.332.887-.315.887-.3.887-.281.887-.263.887-.246.887-.23.887-.212.887-.194.887-.177.887-.159.887-.142.887-.125.887-.107.887-.09.887-.073.887-.055.887-.037.887-.021.887,0,.887.014.887.033.887.049.887.067.887.085.887.1.887.12.887.137.887.155.887.172.887.19.887.207.887.224.887.241.887.258.887.276.887.293.887.31.887.327.887.344.887.361.887.378.887.394.887.412.887.428.887.445.887.461.887.478.887.494.887.511.887.526.887.543.887.559.887.575.887.59.887.607.887.623.887.638.887.654.887.669.887.684.887.7.887.715.887.73.887.744.887.759.887.774.887.788.887.8.887.817.887.831.887.845.887.859.887.873.887.886.887.9.887.913.887.926.887.939.887.953.887.965.887.978.887.99.887,1,.887,1.015.887,1.027.887,1.039.887,1.05.887,1.062.887,1.073.887,1.084.887,1.1.887,1.106L848.7,284l.887,1.127.887,1.137.887,1.148.887,1.158.887,1.167.887,1.177.887,1.186.887,1.2.887,1.2.887,1.213.887,1.223.887,1.23.887,1.238.887,1.247.887,1.255.887,1.262.887,1.269.887,1.277.887,1.284.887,1.291.887,1.3.887,1.3.887,1.31.887,1.317.887,1.322.887,1.328.887,1.333.887,1.339.887,1.343.887,1.348.887,1.353.887,1.358.887,1.361.887,1.365.887,1.37.887,1.373.887,1.376.887,1.38.887,1.382.887,1.385.887,1.387.887,1.389.887,1.392.887,1.393.887,1.395.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.394.887,1.393.887,1.391.887,1.389.887,1.386.887,1.384.887,1.381.887,1.378.887,1.375.887,1.371.887,1.368.887,1.364.887,1.36.887,1.356.887,1.352.887,1.346.887,1.342.887,1.337.887,1.331.887,1.326.887,1.32.887,1.315.887,1.308.887,1.3.887,1.3.887,1.288.887,1.282.887,1.274.887,1.267.887,1.259.887,1.252.887,1.243.887,1.236.887,1.227.887,1.218.887,1.21.887,1.2.887,1.192.887,1.183.887,1.173.887,1.163.887,1.154.887,1.143.887,1.134.887,1.123.887,1.113.887,1.1.887,1.091.887,1.08.887,1.069.887,1.058.887,1.046.887,1.034.887,1.022.887,1.01.887,1,.887.986.887.973.887.96.887.948.887.935.887.922.887.908.887.9.887.881.887.868.887.853.887.84.887.826.887.812.887.8.887.783.887.768.887.754.887.739.887.724.887.709.887.694.887.678.887.663.887.648.887.632.887.617.887.6.887.585.887.569.887.552.887.537.887.521.887.5.887.488.887.471.887.455.887.438.887.422.887.4.887.388.887.371.887.355.887.337.887.321.887.3.887.287.887.269.887.252.887.234.887.218.887.2.887.183.887.166.887.148.887.131.887.113.887.1.887.078.887.06.887.043.887.026.887.008.887-.009.887-.027.887-.045.887-.061.887-.08.887-.1.887-.114.887-.132.887-.148.887-.167.887-.184.887-.2.887-.219.887-.236.887-.253.887-.27.887-.287.887-.3.887-.321.887-.339.887-.355.887-.372.887-.39.887-.405.887-.423.887-.439.887-.456.887-.472.887-.489.887-.505.887-.522.887-.537.887-.554.887-.57.887-.585.887-.6.887-.617.887-.633.887-.649.887-.664.887-.68.887-.694.887-.71.887-.725.887-.739.887-.755.887-.769.887-.784.887-.8.887-.813L1051,441l.887-.84.887-.855.887-.869.887-.882.887-.9.887-.909.887-.922.887-.935.887-.948.887-.961.887-.974.887-.987.887-1,.887-1.011.887-1.023.887-1.035.887-1.047.887-1.058.887-1.069.887-1.081.887-1.091.887-1.1.887-1.113.887-1.124.887-1.134.887-1.144.887-1.154.887-1.163.887-1.174.887-1.183.887-1.192.887-1.2.887-1.21.887-1.219.887-1.227.887-1.236.887-1.244.887-1.252.887-1.26.887-1.267.887-1.275.887-1.282.887-1.289.887-1.3.887-1.3.887-1.308.887-1.315.887-1.32.887-1.326.887-1.332.887-1.337.887-1.342.887-1.347.887-1.352.887-1.356.887-1.361.887-1.364.887-1.368.887-1.372.887-1.375.887-1.378.887-1.381.887-1.384.887-1.387.887-1.389.887-1.391.887-1.393.887-1.394.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.4.887-1.395.887-1.393.887-1.392.887-1.389.887-1.387.887-1.385.887-1.383.887-1.379.887-1.376.887-1.373.887-1.369.887-1.365.887-1.361.887-1.357.887-1.353.887-1.348.887-1.343.887-1.339.887-1.333.887-1.328.887-1.321.887-1.316.887-1.31.887-1.3.887-1.3.887-1.291.887-1.284.887-1.276.887-1.269.887-1.262.887-1.253.887-1.247.887-1.238.887-1.23.887-1.221.887-1.213.887-1.2.887-1.2.887-1.185.887-1.176.887-1.167.887-1.157.887-1.147.887-1.137.887-1.126.887-1.116.887-1.106.887-1.095.887-1.083.887-1.073.887-1.061.887-1.049.887-1.038.887-1.026.887-1.014.887-1,.887-.99.887-.977.887-.965.887-.952.887-.939.887-.926.887-.913.887-.9.887-.886.887-.873.887-.858.887-.845.887-.83.887-.817.887-.8.887-.788.887-.773.887-.759.887-.744.887-.729.887-.714.887-.7.887-.684.887-.669.887-.652.887-.638.887-.621.887-.606.887-.59.887-.574.887-.558.887-.542.887-.526.887-.51.887-.493.887-.476.887-.46.887-.444.887-.427.887-.41.887-.394.887-.377.887-.36.887-.343.887-.326.887-.309.887-.292.887-.275.887-.258.887-.24.887-.223.887-.205.887-.189.887-.171.887-.153.887-.137.887-.119.887-.1.887-.085.887-.066.887-.049.887-.031.887-.014.887,0,.887.021.887.038.887.056.887.074.887.091.887.109.887.126.887.144.887.161.887.178.887.2.887.212.887.23.887.247.887.265.887.281.887.3.887.315.887.333.887.35.887.366.887.384.887.4.887.417.887.434.887.451.887.467.887.484.887.5.887.516.887.532.887.549.887.564.887.581.887.6.887.612.887.628.887.643.887.659.887.675.887.689.887.705.887.719.887.735.887.75.887.765.887.779.887.794.887.807.887.823.887.836.887.85.887.864.887.878.887.891.887.9.887.918.887.931.887.944.887.957.887.97.887.983.887.994.887,1.007.887,1.019.887,1.031.887,1.042.887,1.054.887,1.066.887,1.077.887,1.088.887,1.1.887,1.11.887,1.12.887,1.131.887,1.141.887,1.151.887,1.161.887,1.171.887,1.18.887,1.19.887,1.2.887,1.207.887,1.216.887,1.225.887,1.233.887,1.241.887,1.249.887,1.258.887,1.264.887,1.273.887,1.279.887,1.286.887,1.293.887,1.3.887,1.306.887,1.313.887,1.318.887,1.324.887,1.33.887,1.335.887,1.341.887,1.346.887,1.35.887,1.354.887,1.359.887,1.363.887,1.367.887,1.371.887,1.374.887,1.378.887,1.38.887,1.383.887,1.386.887,1.388.887,1.39.887,1.392.887,1.394.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.4.887,1.395.887,1.394.887,1.392.887,1.39.887,1.388.887,1.385.887,1.383.887,1.38.887,1.377.887,1.374.887,1.37.887,1.367.887,1.363.887,1.359.887,1.354.887,1.35.887,1.345.887,1.34.887,1.335.887,1.33.887,1.324.887,1.318.887,1.313.887,1.306.887,1.3"
              fill="none"
              stroke="#02063b"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-miterlimit="10"
              stroke-width="5"
              id="path"
            />
          </g>
        </svg>
        <div class="ball ball-2"></div>
        <div class="ball ball-1"></div>
      </section>
    </div>
  </page-container>
</template>

<script>
import gsap from 'gsap';
import MotionPathPlugin from 'gsap/MotionPathPlugin';
import emailjs from '@emailjs/browser';
import { mapGetters, mapMutations } from 'vuex';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import OfferModal from '@/components/OfferModal.vue';

gsap.registerPlugin(MotionPathPlugin);
emailjs.init('ycjl1SO8_ksGopBUE');

export default {
  name: 'Home',

  components: {
    LoadingSpinner,
    OfferModal,
  },

  data() {
    return {
      currTestimonial: 0,
      tween: null,
      loaded: false,
      isLoading: false,
      success: false,
      error: false,
      errorMsg:
        'Sorry we were not able to send your message. Please try again or check your internet connection.',
      email: null,
      message: null,
      showModal: false,
    };
  },

  computed: {
    projects() {
      return this.PROJECTS();
    },

    moreProjects() {
      return this.projects.slice(-4);
    },

    testimonials() {
      return this.TESTIMONIALS();
    },

    numTestimonials() {
      return this.testimonials.length;
    },

    showRightArr() {
      return this.currTestimonial < this.numTestimonials - 1;
    },

    showLeftArr() {
      return this.currTestimonial > 0;
    },
  },

  methods: {
    ...mapGetters([
      'PROJECTS',
      'TESTIMONIALS',
      'ROUTE_TO_CONTACT',
      'AUTO_SHOW_MODAL',
    ]),
    ...mapMutations(['RESET_SHOW_MODAL']),

    routeToProjects() {
      this.$router.push({
        name: 'Projects',
      });
    },

    scroll(num) {
      // 1. Remove active form from all btns
      const btns = [...this.$refs.selector.children];
      btns.forEach((el) => {
        el.classList.remove('active');
      });

      // 2. Calculate scroll distance according to the btn clicked
      const scroll = num * 100;

      // 3. Add active form to current slide btn and navigate to selected project
      this.$refs.projectsSlider.style.transform = `translateY(-${scroll}vh)`;
      btns[num].classList.add('active');
    },

    slideRight() {
      if (this.currTestimonial === 2) {
        gsap.to('.testimonials-slider', {
          keyframes: [
            { duration: 0.2, x: '-215vw' },
            { duration: 0.2, x: '-200vw' },
          ],
        });
        return; // should actually hide the button
      }
      const move = ++this.currTestimonial * 100;
      this.$refs.testimonialSlider.style.transform = `translateX(-${move}vw)`;
    },

    slideLeft() {
      if (this.currTestimonial === 0) {
        gsap.to('.testimonials-slider', {
          keyframes: [
            { duration: 0.2, x: -80 },
            { duration: 0.2, x: 80 },
            { duration: 0.2, x: 0 },
          ],
        });
        return; // should actually hide the button
      }
      const move = --this.currTestimonial * 100;
      this.$refs.testimonialSlider.style.transform = `translateX(-${move}vw)`;
    },

    changeFormState(reset = null) {
      if (reset) {
        this.message = '';
        this.email = '';
      }
      this.$refs.email.disabled = !this.$refs.email.disabled;
      this.$refs.contactMsg.disabled = !this.$refs.contactMsg.disabled;
      this.$refs.contactBtn.disabled = !this.$refs.contactBtn.disabled;
    },

    submitForm() {
      this.isLoading = true;
      this.changeFormState();

      emailjs
        .send('service_btpjmdx', 'template_kmes304', {
          message: this.message,
          reply_to: this.email,
        })
        .then(() => {
          this.isLoading = false;
          this.success = true;
          setTimeout(() => {
            this.changeFormState(true);
            this.success = false;
          }, 3000);
        })
        .catch(() => {
          this.isLoading = false;
          this.error = true;
          setTimeout(() => {
            this.changeFormState();
            this.error = false;
          }, 3000);
        });
    },

    toggleModal() {
      this.showModal = !this.showModal;
    },
  },

  mounted() {
    if (this.ROUTE_TO_CONTACT()) {
      document.getElementById('contactLink').click();
    }

    if (this.AUTO_SHOW_MODAL()) {
      setTimeout(() => {
        this.showModal = true;
        this.RESET_SHOW_MODAL();
      }, 2000);
    }

    setTimeout(() => {
      this.loaded = true;
    }, 3000);

    const tl = gsap.timeline({
      // duration: 10,
      repeat: -1,
      repeatDelay: 1,
      yoyo: true,
      ease: 'circ',
    });

    tl.to('.ball-1', {
      duration: 20,
      rotate: '100%',
      motionPath: {
        path: '#path',
        align: '#path',
        autoRotate: true,
        alignOrigin: [0.5, 0.5],
      },
    }).to(
      '.ball-2',
      {
        duration: 20,
        rotate: '100%',
        motionPath: {
          path: '#path-2',
          align: '#path-2',
          autoRotate: true,
          start: 1,
          end: 0,
          alignOrigin: [0.5, 0.5],
        },
      },
      1
    );
  },

  beforeRouteEnter(_2, _, next) {
    document.querySelector('html').classList.add('smooth');
    next();
  },

  beforeRouteLeave() {
    document.querySelector('html').classList.remove('smooth');
  },
};
</script>

<style lang="scss" scoped>
@function tracking($size) {
  @return calc(1em * 0.001 * $size);
}

.active {
  background: var(--color-grid-grey) !important;
  height: 2.7rem !important;
}

::-webkit-scrollbar {
  height: 0.3rem;
}

/* Track */
::-webkit-scrollbar-track {
  background: #d1d0d0;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: var(--color-main-accent);
  border-radius: 3rem;
}

.landing-page {
  .onboard {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;

    @media screen and (max-width: 500px) {
      height: 91vh;
    }

    h2,
    h1 {
      font-size: 8.9rem;
      font-family: var(--font-header);
      letter-spacing: tracking(5);
      font-weight: 400;
      z-index: 100;
      position: relative;

      @media screen and (max-width: 700px) {
        font-size: 7.9rem;
      }
      @media screen and (max-width: 400px) {
        font-size: 6.5rem;
      }
      @media screen and (max-width: 300px) {
        font-size: 5.5rem;
      }
    }

    // h1 {
    //   text-align: center;

    //   span {
    //     display: block;
    //     font-size: 8.9rem;
    //     font-family: var(--font-header);
    //     letter-spacing: tracking(5);
    //     font-weight: 400;
    //     z-index: 100;
    //     position: relative;

    //     @media screen and (max-width: 700px) {
    //       font-size: 7.9rem;
    //     }
    //     @media screen and (max-width: 400px) {
    //       font-size: 6.5rem;
    //     }
    //     @media screen and (max-width: 300px) {
    //       font-size: 5.5rem;
    //     }
    //   }
    // }

    .highlight {
      .line {
        height: 0.5rem;
        background: #0c21e1;
        border-radius: 3rem;
        transform: rotate(-5deg) translateY(-1.5rem);
        position: relative;

        @media screen and (max-width: 600px) {
          transform: rotate(-5deg) translateY(-1rem);
        }
      }
    }

    .chevron {
      position: absolute;
      bottom: 4.1rem;
      cursor: pointer;
      // transform: scale(0.9);
      width: 6rem;
      transition: all 0.3s ease;
      animation: bounce ease-in-out 0.85s infinite alternate;
    }
  }

  .showcase {
    height: 100vh;
    overflow: hidden;
    scrollbar-width: none;
    position: relative;

    @media screen and (max-width: 500px) {
      height: 465px;
      overflow-y: scroll;
      scroll-snap-type: y mandatory;

      ::-webkit-scrollbar {
        display: initial;
      }
    }

    &::-webkit-scrollbar {
      display: none;
    }

    .projects {
      height: 200vh;
      transition: all 0.5s ease;

      @media screen and (max-width: 500px) {
        height: 500%;
      }

      .project {
        background: white;
        height: 50%;
        padding: 7.8rem 8.5% 7.8rem 0;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;

        @media screen and (max-width: 500px) {
          height: 20%;
          scroll-snap-align: center;
          // flex-direction: column;
          padding: 0 5rem 7.8rem 5rem !important;
        }

        &-title-container {
          width: 9%;
          height: 100%;
          position: relative;

          @media screen and (max-width: 500px) {
            width: 100%;
            height: 7.8rem;
          }

          .project-title {
            position: absolute;
            font-size: 1.9rem;
            font-family: var(--font-secondary);
            font-weight: 400;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(-90deg);
            width: max-content;

            @media screen and (max-width: 500px) {
              transform: translate(-50%, -50%) rotate(0deg);
            }
          }
        }

        &-content {
          flex: 1;
          height: 100%;
          position: relative;

          &:hover {
            .description {
              visibility: visible;
            }
            .content-cover {
              filter: blur(2px) brightness(60%);
            }
          }

          .content-cover {
            width: 100%;
            height: 100%;
            display: grid;
            grid-template-columns: repeat(2, 50%);
            grid-template-rows: repeat(2, 50%);

            &-img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              object-position: center;
              cursor: pointer;
              transition: all 0.2s ease;
            }
          }

          .description {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 2rem;
            visibility: hidden;
            transition: all 0.1s ease;

            &-text {
              font-size: 1.9rem;
              text-align: center;
              color: var(--color-primary);
              cursor: default;
            }

            &-link {
              // padding: 1.6rem 1.9rem 1.4rem 1.9rem;
              padding: 1.6rem 3rem 1.4rem 3rem;
              border-bottom: 1px solid var(--color-primary);
              // border: 2px solid var(--color-primary);
              cursor: pointer;
              position: relative;

              &:hover {
                .description-link-background {
                  height: 100%;
                }

                .description-link-btn {
                  color: var(--color-text);
                }
              }

              &-btn {
                text-decoration: none;
                font-weight: bold;
                font-size: 1.6rem;
                color: var(--color-primary);

                @media screen and (max-width: 600px) {
                  color: var(--color-text);
                }
              }

              &-background {
                background: var(--color-primary);
                position: absolute;
                bottom: 0;
                left: 0;
                height: 0;
                width: 100%;
                z-index: -1;
                transition: all 0.3s ease;

                @media screen and (max-width: 600px) {
                  height: 100%;
                }
              }
            }
          }
        }
      }
    }

    .selector {
      width: min-content;
      position: absolute;
      right: 3.7%;
      top: 50%;
      transform: translateY(-50%);

      @media screen and (max-width: 500px) {
        display: none;
      }

      &-btn {
        width: 1.4rem;
        height: 1.4rem;
        border-radius: 1.4rem;
        border: 1px solid var(--color-grid-grey);
        background: white;
        cursor: pointer;
        transition: all 0.5s ease;
      }

      &-btn:not(.selector-btn:last-child) {
        margin-bottom: 1rem;
      }
    }
  }

  .testimonials {
    position: relative;
    overflow: hidden;

    @media screen and (max-width: 700px) {
      overflow-x: scroll;
      scrollbar-width: none;
      scroll-snap-type: x mandatory;
    }

    #right-arrow,
    #left-arrow {
      position: absolute;
      top: 45%;
      z-index: 100;
      cursor: pointer;
      transition: all 0.5s ease;

      @media screen and (max-width: 700px) {
        display: none;
      }
    }

    #right-arrow {
      transform: rotate(-90deg) translateY(-45%);
      right: 4.1rem;
      width: 5.5rem;

      @media screen and (max-width: 800px) {
        right: 1.1rem;
      }

      &:hover {
        transform: rotate(-90deg) translateY(-45%) scale(1.15);
      }
    }

    #left-arrow {
      transform: rotate(90deg) translateY(-45%) scale(0.9);
      left: 4.1rem;
      width: 5.5rem;

      @media screen and (max-width: 800px) {
        left: 1.1rem;
      }

      &:hover {
        transform: rotate(90deg) translateY(-45%) scale(1.15);
      }
    }

    &-slider {
      display: flex;
      transition: all 0.5s ease;

      @media screen and (max-width: 600px) {
        transform: translateX(0);
      }

      .testimonial {
        width: 100vw;
        padding: 7rem 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        @media screen and (max-width: 700px) {
          scroll-snap-align: center;
        }

        .testimony {
          max-width: 65%;
          position: relative;

          &-comment {
            font-size: 5.1rem;
            font-family: var(--font-header);
            text-align: center;

            @media screen and (max-width: 500px) {
              font-size: 3.5rem;
            }
          }

          #quote-left {
            position: absolute;
            top: -2rem;
            left: -6rem;
            width: 3.5rem;

            @media screen and (max-width: 500px) {
              width: 2rem;
              top: -1rem;
              left: -3rem;
            }
          }

          #quote-right {
            position: absolute;
            bottom: 1rem;
            right: -6rem;
            width: 3.5rem;

            @media screen and (max-width: 500px) {
              width: 2rem;
              bottom: 1rem;
              right: -3rem;
            }
          }
        }

        .divider {
          height: 1px;
          width: 22%;
          background: var(--color-grey);
          margin: 4.95rem 0 4.55rem 0;
        }

        .profile {
          display: flex;
          align-items: center;
          gap: 2.1rem;

          &-img-container {
            width: 9.9rem;
            height: 9.9rem;
            background-size: cover;
            background-position: center;
            border-radius: 50%;
          }

          &-details {
            .name {
              font-size: 1.8rem;
              font-family: var(--font-secondary);
              margin-bottom: 0.2rem;
            }

            .title {
              font-size: 1.8rem;
            }
          }
        }
      }
    }
  }

  .contact {
    background: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 5rem 0 8rem 0;
    position: relative;
    z-index: 100;

    &-title {
      font-size: 6.3rem;
      font-family: var(--font-header);
      margin-bottom: 3.4rem;

      @media screen and (max-width: 500px) {
        font-size: 5rem;
      }
    }

    &-form {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 46.9%;

      @media screen and (max-width: 500px) {
        width: 70%;
      }

      .form-control {
        display: flex;
        flex-direction: column;
        gap: 1.4rem;
        width: 100%;
        margin-bottom: 3.3rem;

        &-label {
          font-size: 1.9rem;
          font-family: var(--font-secondary);
        }

        &-input {
          border-radius: 0.7rem;
          border: none;
          background-color: #2028c40e;
          font-size: 1.9rem;
          padding: 1.5rem;

          &:focus {
            outline: 2px solid var(--color-main-accent);
          }
        }

        .message-input {
          resize: none;
          scrollbar-width: 1px;
          width: 100%;
          height: 27.2rem;

          &::-webkit-scrollbar {
            display: none;
          }
        }
      }
    }

    &-btn {
      // padding: 1.5rem 9rem;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 6rem;
      width: 42%;
      color: var(--color-main-accent);
      border: 2px solid var(--color-main-accent);
      border-radius: 0.8rem;
      background: none;
      cursor: pointer;
      transition: all 0.5s ease-in-out;

      @media screen and (max-width: 500px) {
        width: 50%;
      }

      span {
        font-size: 1.9rem;
        font-family: var(--font-secondary);
        letter-spacing: tracking(203);
        transition: all 0.5s ease-in-out;
      }

      &-icon {
        width: 2.5rem;
      }

      &:hover {
        span {
          color: var(--color-primary);
          letter-spacing: 0.1rem;
        }

        .loader {
          border-top-color: var(--color-primary);
          border-bottom-color: var(--color-primary);
        }

        background: var(--color-main-accent);
        border: 2px solid transparent;
      }
    }
  }

  .offer:has(> .offer-btn:hover) {
    background-color: black;
    .offer-title {
      color: var(--color-primary);
    }
  }

  .offer {
    position: relative;
    height: 37vh;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15rem;
    overflow: hidden;
    transition: all 0.3s ease-in-out;

    @media screen and (max-width: 960px) {
      padding: 0 5rem;
    }

    @media screen and (max-width: 600px) {
      height: auto;
      flex-direction: column;
      gap: 5rem;
      padding: 3rem 5rem;
    }

    @media screen and (max-width: 500px) {
      flex-direction: column;
      padding: 5rem 5rem;
    }

    .title-container {
      display: flex;
      flex-direction: column;
      align-items: center;

      .offer-title,
      span {
        font-family: var(--font-header);
        font-size: 5rem;
        z-index: 100;
        transition: all 0.3s ease-in-out;
      }

      span {
        color: var(--color-cta);
        // text-transform: uppercase;
      }
    }

    &-btn {
      padding: 2rem 6rem;
      font-family: var(--font-secondary);
      font-size: 1.7rem;
      letter-spacing: tracking(203);
      border: none;
      border-radius: 0.8rem;
      box-shadow: 0 1px 6px rgba(0, 0, 0, 0.16);
      background-color: var(--color-cta);
      cursor: pointer;
      z-index: 100;
      transition: all 0.3s ease-in-out;

      &:hover {
        transform: translateY(-2px) scale(1.01);
      }

      &:active {
        transform: translateY(0px) scale(1);
      }
    }

    #svg {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
    }

    .ball {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 13rem;
      height: 13rem;
      border-radius: 50%;
      background: linear-gradient(to top right, #090979, #00d4ff);
      filter: opacity(60%) blur(0.5px);
      border: none;
      box-shadow: 1px 1px 1px rgba($color: #000000, $alpha: 0.16);
    }
  }
}

.modal-enter-from {
  opacity: 0;
}

.modal-enter-to {
  opacity: 1;
}

.modal-enter-active {
  transition: all 1s ease-in-out;
}

@keyframes bounce {
  0% {
    bottom: 6.1rem;
    transform: scale(0.85);
  }

  100% {
    bottom: 4.1rem;
    transform: scale(1);
  }
}
</style>
